import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/BlogContent.css';


const BlogContent = ({displayedBlogs }) => {

  return (
    <div className='HomeBlog_gallery_container blogContent_container'>
            <div className='homeBlog_gallery_content'>
            {
                displayedBlogs.map((blog) =>(
                <div className='HomeBlog_gallery1' key={blog.id}>
                    <div className='HomeBlog_img1_container'>
                        <img src={blog.VatAfrica} alt="Gallery img" />
                        <div className='HomeBlog_btn'>
                            <p className='HomeBlog_btnp'>
                                Technology
                            </p>
                        </div>
                    </div>
                    
                    <div className='HomeBlog_card_container' >
                        <p className='HomeBlog_card_text1'>
                            Posted on - {blog.DatePosted}
                        </p>
                        <h6 className='HomeBlog_card_texth6'>
                            {blog.BlogHead}
                        </h6>
                        <p className='HomeBlog_card_text2'>
                            {blog.blogText1}
                        </p>
                        <span className='HomeBlog_card_text2span'>
                            <Link to={`/blognews/${blog.id}`}>Continue reading</Link>
                        </span>
                    </div>
                </div>
                ))
            }
                
            </div>
    </div>
  )
}

export default BlogContent;